import React from "react";
import { useNavigate } from "react-router-dom";
import { objToFormData } from "../../../helpers/FormHelper";
import { createChallenge } from "../../../actions/mine_craft/challengesActions";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { setNewError, setNewParams } from "../../../store/mine_craft/challengesSlice";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const New = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const newParams  = useAppSelector(state => state.mineCraft.challenges.newParams);
  const error = useAppSelector(state => state.mineCraft.challenges.newError);

  let params = newParams;

  function onCloseError() {
    dispatch(setNewError(null));
  }

  function onClose() {
    dispatch(setNewParams(null));
  }

  function onFinish(rawData: any) {
    const data = { ...rawData };
    delete data.range;

    data.start_at = rawData.range[0].toString();
    data.end_at   = rawData.range[1].toString();

    const formData = objToFormData(data);
    handleSave(formData).catch(console.error);
  }

  async function handleSave(data: object) {
    const resultAction = await dispatch(createChallenge(data));

    if (createChallenge.fulfilled.match(resultAction)) {
      onClose();
      navigate(0);
    }
  }

  return (
    <DrawerRight
      open={!!params}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-new-challenge'>
        <h6 className="v-content-label">Create Challenge</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form onFinish={onFinish} params={params} />
      </div>
    </DrawerRight>
  )
}

export default New;
